/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const workInfoBusinessTypeQuery = params => {
  return axios.post(`${base}/work_info_business_type/query`, params)
}

export const workInfoBusinessTypeCreate = params => {
  return axios.post(`${base}/work_info_business_type/create`, params)
}

export const workInfoBusinessTypeEdit = params => {
  return axios.post(`${base}/work_info_business_type/${params.id}/edit`, params)
}

export const workInfoBusinessTypeGet = id => {
  return axios.get(`${base}/work_info_business_type/${id}`)
}

export const workInfoBusinessTypeDelete = id => {
  return axios.post(`${base}/work_info_business_type/${id}/delete`)
}




// WEBPACK FOOTER //
// ./src/views/work-info-business-type/work-info-business-type.api.js